import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'palavra1',
})
export class Palavra1Pipe implements PipeTransform {
  transform(value: string): string | boolean {
    if (value == null) {
      return value;
    }
    const words = value.split(' ');
    const nWords = words.length - 1;
    const p1 = words[0];
    const pN = words[nWords];
    const p1PN = p1 + " " + pN
    return words.length > 0 ? p1PN : value;
  }
}
